<template>
  <v-container fluid class="grey lighten-3">

    <v-row class="inner-content">
      <v-col>
        <UsersTable />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: 'Users',

  components: {
    UsersTable: () => import('@/components/tables/UsersTable.vue')
  },
}
</script>
